import { createReducer, on } from '@ngrx/store';
import {
  clearTool,
  getLocalizationSuccess,
  removeAlert,
  resetAlerts,
  removeSuccessAlerts,
  setAlert,
  setBreeds,
  setPrevTool,
  setTool,
  toggleLoader,
  togglePopinLoader,
  toggleProgressBar,
  setStepperActiveStep,
  setToast,
  removeToast,
} from './core.actions';
import { initialCoreState } from './core.state';
import { RCAlertType } from '@rc/ui';

export const coreReducer = createReducer(
  initialCoreState,
  on(toggleLoader, (state, { value, transparent }) => ({
    ...state,
    showLoader: value,
    loaderTransparent: value ? !!transparent : false,
  })),
  on(togglePopinLoader, (state, { value }) => ({
    ...state,
    showPopinLoader: value,
  })),
  on(toggleProgressBar, (state, { value }) => ({
    ...state,
    showProgressBar: value,
  })),
  on(getLocalizationSuccess, (state, { localization }) => ({
    ...state,
    localization,
  })),
  on(setTool, (state, { tool, tool_flow_id }) => ({
    ...state,
    tool,
    tool_flow_id,
  })),
  on(setPrevTool, (state, { prevTool }) => ({
    ...state,
    prevTool,
  })),
  on(clearTool, (state) => ({
    ...state,
    tool: null,
    tool_flow_id: null,
  })),
  on(setBreeds, (state, { breeds }) => ({
    ...state,
    breeds,
  })),
  on(setAlert, (state, { alert }) => ({
    ...state,
    alerts: [...state.alerts, alert],
  })),
  on(removeAlert, (state, { alert }) => {
    const alerts = state.alerts.filter((a) => a.message !== alert.message);
    return {
      ...state,
      alerts,
    };
  }),
  on(resetAlerts, (state, { ids = [] }) => ({
    ...state,
    alerts: ids.length ? state.alerts.filter((item) => !ids.includes(item.id)) : [],
  })),
  on(removeSuccessAlerts, (state) => {
    const alerts = state.alerts.filter((a) => a.alertType !== RCAlertType.SUCCESS);
    return {
      ...state,
      alerts,
    };
  }),
  on(setStepperActiveStep, (state, { index }) => {
    const stepperItems = state.stepperItemsPerTool[state.tool]?.map((item, i) => ({ ...item, isActive: i === index }));
    const stepperItemsLegacy = state.stepperItemsPerToolLegacy[state.tool]?.map((item, i) => ({ ...item, isActive: i === index }));
    return {
      ...state,
      stepperItemsPerTool: {
        ...state.stepperItemsPerTool,
        [state.tool]: stepperItems,
      },
      stepperItemsPerToolLegacy: {
        ...state.stepperItemsPerToolLegacy,
        [state.tool]: stepperItemsLegacy,
      },
    };
  }),
  on(setToast, (state, { toast }) => ({
    ...state,
    toasts: [...state.toasts, toast],
  })),
  on(removeToast, (state, { id }) => {
    const toasts = state.toasts.filter((a) => a.id !== id);
    return {
      ...state,
      toasts,
    };
  }),
);
